import { render, staticRenderFns } from "./transform.vue?vue&type=template&id=0eaaf85c&scoped=true&"
import script from "./transform.vue?vue&type=script&lang=ts&"
export * from "./transform.vue?vue&type=script&lang=ts&"
import style0 from "./transform.vue?vue&type=style&index=0&id=0eaaf85c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eaaf85c",
  null
  
)

export default component.exports